import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=f168f0b8&scoped=true&"
import script from "./Usuarios.vue?vue&type=script&lang=js&"
export * from "./Usuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f168f0b8",
  null
  
)

export default component.exports